import React, { useState } from "react";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import { Tooltip } from "@my-scoot/component-library-legacy";
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";
import { handleDateFormatV2, pluralise } from "utils/Utils";
import HistoryIcon from "@material-ui/icons/History";
import SeeMoreStatsAudienceModal from "./SeeMoreStatsAudienceModal";

const SeeMoreStatsModal = ({
  record,
  columns = [],
  isShowRefreshStat = false,
  emailRetryText = false,
  isWhatsApp = false,
  dripSource,
  onOpenAudience,
}) => {
  const [selectedField, setSelectedField] = useState(null);
  const [selectedTitle, setSelectedTitle] = useState("");

  if (!record) return null;

  const modalContent = columns
    .filter(
      (column) => !column.hiddenInDetails && !column.hidden && column.headerName
    )
    .map((column) => {
      let value = record[column.field];

      if (column.valueFormatter) {
        value = column.valueFormatter(record);
      }

      if (value === undefined || value === null || value === "") {
        value = column.emptyField || "N/A";
      }

      return {
        field: column.field,
        title: column.headerName,
        value,
        info: column.info,
      };
    });

  const rawFailed =
    record?.failed_count ?? record?.total_failed ?? record?.failed ?? 0;
  const failedCount =
    typeof rawFailed === "number" ? rawFailed : Number(rawFailed) || 0;

  const isEmail = emailRetryText || !isWhatsApp;
  const retryExpiryDate = record?.retry_expiry || record?.retry_expiry_at;
  const hasRetryExpiry = Boolean(retryExpiryDate);

  const showEmailRetryText = isEmail ? failedCount > 0 : hasRetryExpiry;

  return (
    <div className="tw-py-3">
      {modalContent.map((item, index) => (
        <React.Fragment key={item.title}>
          <div className="tw-flex tw-justify-between tw-gap-3 tw-text-sm">
            <div className="tw-flex tw-gap-1 tw-items-center">
              <span className="tw-font-medium">{item.title}</span>
              {item.info && (
                <Tooltip
                  arrow
                  color="primary"
                  placement="top"
                  title={item.info}
                >
                  <InfoOutlinedIcon
                    className="tw-text-[#8A8A8A]"
                    style={{
                      fontSize: 16,
                      cursor: "pointer",
                    }}
                  />
                </Tooltip>
              )}
            </div>

            <div
              className="tw-flex tw-items-center tw-gap-1 tw-text-[#493AB1] tw-cursor-pointer"
              onClick={() => {
                if (onOpenAudience) {
                  onOpenAudience(item.field);
                  return;
                }
                setSelectedField(item.field);
                setSelectedTitle(item.title);
              }}
            >
              <div className="tw-text-right">
                {`${item.value} ${
                  item.field === "attempted_for"
                    ? pluralise("member", item.value)
                    : "people"
                }`}
              </div>
              <KeyboardArrowRightIcon style={{ fontSize: 18 }} />
            </div>
          </div>

          {index < modalContent.length - 1 && (
            <hr className="tw-border-none tw-h-[1px] tw-bg-[#E7E6E4] tw-my-[10px]" />
          )}
        </React.Fragment>
      ))}

      {isShowRefreshStat && showEmailRetryText && (
        <div className="tw-mt-4 tw-flex tw-items-start tw-gap-3 tw-rounded-lg tw-bg-[#FFF5CF] tw-p-2">
          <div className="tw-mt-[1px] tw-flex tw-flex-shrink-0 tw-items-center tw-text-[#9B7F16]">
            <HistoryIcon style={{ fontSize: 22 }} />
          </div>

          <div className="tw-min-w-0 tw-flex-1">
            {isEmail ? (
              <p className="tw-m-0 tw-text-[14px] tw-leading-6 tw-text-[#272522]">
                <span className="tw-font-semibold">
                  Some failed emails are retried automatically
                </span>{" "}
                — refresh to see if any were delivered.
              </p>
            ) : (
              <p className="tw-m-0 tw-text-[14px] tw-leading-6 tw-text-[#272522]">
                <span className="tw-font-semibold">
                  Retry trigger is enabled
                </span>{" "}
                for this campaign
                {retryExpiryDate ? (
                  <>
                    {" "}
                    until{" "}
                    <span className="tw-font-semibold">
                      {handleDateFormatV2(retryExpiryDate)}.
                    </span>
                  </>
                ) : (
                  "."
                )}{" "}
                Make sure to refresh the stats to see updates.
              </p>
            )}
          </div>
        </div>
      )}

      {selectedField && !onOpenAudience && (
        <SeeMoreStatsAudienceModal
          open={Boolean(selectedField)}
          onClose={() => {
            setSelectedField(null);
            setSelectedTitle("");
          }}
          campaignUid={record.uuid || record.email_key}
          field={selectedField}
          title={selectedTitle}
          isShowRefreshStat={isShowRefreshStat}
          isWhatsApp={isWhatsApp}
          dripSource={dripSource}
        />
      )}
    </div>
  );
};

export default SeeMoreStatsModal;
